import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import {useState} from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Report from './Report';
import CloseIcon from '@mui/icons-material/Close';
import {useNavigate} from 'react-router-dom';
import {URLS} from '../../constants/appConstants';

export default function CardHeaderAction({handleSkip, showEditOption}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [isReportOpen, setIsReportOpen] = useState(false)
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return <>
    <IconButton aria-label="settings" onClick={handleClick}>
      <MoreVertIcon/>
    </IconButton>
    <IconButton aria-label="settings" onClick={() => handleSkip(true)}>
      <CloseIcon/>
    </IconButton>
    <Menu
      id="card-header-action-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
    >
      <MenuItem onClick={() => setIsReportOpen(!isReportOpen)}>
        Report
      </MenuItem>
      {showEditOption &&
        <MenuItem onClick={() => navigate(`${URLS.QUESTION_CREATE}?edit=true`)}>
          Edit
        </MenuItem>
      }
    </Menu>
    <Report open={isReportOpen} handleReportClose={() => setIsReportOpen(false)}/>
  </>
}
